import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { XCircle, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const PaymentCancelPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 flex items-center justify-center p-4">
      <Card className="bg-white/10 border-white/20 backdrop-blur-sm max-w-md w-full" data-testid="payment-cancel-card">
        <CardContent className="p-8 text-center">
          <div className="mx-auto w-20 h-20 rounded-full bg-gray-500/20 flex items-center justify-center mb-4">
            <XCircle className="h-12 w-12 text-gray-400" />
          </div>
          <h2 className="text-2xl font-bold text-white mb-2">Payment Cancelled</h2>
          <p className="text-blue-200 mb-6">
            Your payment was cancelled. No charges were made to your account.
          </p>
          
          <div className="space-y-3">
            <Link to="/buy-credits" className="block">
              <Button className="w-full bg-blue-600 hover:bg-blue-700" data-testid="try-again-btn">
                <ArrowLeft className="mr-2 h-4 w-4" />
                Back to Buy Credits
              </Button>
            </Link>
            <Link to="/" className="block">
              <Button variant="outline" className="w-full bg-white/10 border-white/20 text-white hover:bg-white/20">
                Go to Dashboard
              </Button>
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PaymentCancelPage;
